export default {
  blue: '#003057',
  lightBlue: '#608FBA',
  grey: '#46464a',
  darkGrey: '#666562',
  translucentGrey: 'rgba(0,0,0,0.85)',
};



// WEBPACK FOOTER //
// ./src/Colors.js